import React, { memo, ReactElement } from 'react'
import styled from 'styled-components'

type RecordTypes = WellDto | InterventionsDto | SectionDto | RunDto | TubularTypeDto

interface CustomExpandRowIconProps {
    expanded: boolean
    onExpand: (record: RecordTypes, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    record: RecordTypes
}

export const CustomExpandRowIcon = memo(
    ({ expanded, onExpand, record }: CustomExpandRowIconProps): ReactElement => {
        return (
            <CustomExpandRowIconContainer>
                <button className="custom-expand-icon" onClick={e => onExpand(record, e)}>
                    <i className={`fas fa-angle-${expanded ? 'up' : 'down'}`} />
                </button>
            </CustomExpandRowIconContainer>
        )
    }
)

CustomExpandRowIcon.displayName = 'CustomExpandRowIcon'

const CustomExpandRowIconContainer = styled.div`
    margin-right: 8px;

    .custom-expand-icon {
        border: none;

        background-color: transparent;

        i {
            font-size: 16px;
            line-height: 14px;
        }
    }
`
